module.exports = __webpack_public_path__ + "static/media/isdoctorplan-bariatric2@2x.73120158.png";